// extracted by mini-css-extract-plugin
export default {"wrapper":"jA-z","button":"kA-z","alternate":"lA-z","disabled":"mA-z","paymentWarning":"nA-z","fadeIn":"oA-z"};